import { fullfillClicksDataLayer, fullfillImpressionsDataLayer } from 'src/utils/analytics/dataLayer';


const setContentDependingOnOffersCount = ({ employerName, employerId, offers }, index) => (
  offers.length === 0 ? {
    name: employerName,
    id: `${employerId}`,
    price: '1',
    brand: employerName,
    category: '',
    variant: '',
    list: 'znajdz_prace_w_sg',
    position: `${index + 1}`,
    dimension6: '',
    dimension7: '',
    dimension8: '',
    dimension9: '',
    dimension10: ''
  } : offers.map(offer => (
    {
      name: offer.title,
      id: `${offer.commonOfferId}`,
      price: '1',
      brand: employerName,
      category: offer.categories,
      variant: offer.commonOfferLocations,
      list: 'znajdz_prace_w_sg',
      position: `${index + 1}`,
      dimension6: '',
      dimension7: '',
      dimension8: '',
      dimension9: '',
      dimension10: ''
    }
  ))
);

const setApplyToImpressions = (employers) => {
  const impressions = employers.map(
    setContentDependingOnOffersCount
  ).flat();
  fullfillImpressionsDataLayer(impressions);
};

const collectOfferClicks = (event, offer, url) => {
  event.preventDefault();

  const {
    index, title, commonOfferId, employerName, categories, location
  } = offer;

  const list = 'znajdz_prace_w_sg';
  const clickData = {
    name: title,
    id: commonOfferId,
    price: '1',
    brand: employerName,
    category: categories,
    variant: location,
    position: `${index + 1}`,
    dimension6: '',
    dimension7: '',
    dimension8: '',
    dimension9: '',
    dimension10: ''
  };

  fullfillClicksDataLayer(list, clickData);

  window.location.assign(url);
};

const collectEmployerClick = (event, employer, url) => {
  event.preventDefault();

  const list = 'znajdz_prace_w_sg';
  const clickData = {
    name: employer.employerName,
    id: employer.employerId,
    price: '1',
    brand: employer.employerName,
    category: '',
    variant: '',
    position: `${employer.index + 1}`,
    dimension6: '',
    dimension7: '',
    dimension8: '',
    dimension9: '',
    dimension10: ''
  };

  fullfillClicksDataLayer(list, clickData);

  window.location.assign(url);
};

export {
  setApplyToImpressions,
  collectEmployerClick,
  collectOfferClicks
};
